import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class ForceUpdateService {

    showLoaderHttpOptions = { headers: { 'hideLoader': 'true' } };

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    addConfig(versionObj) {
        let header = this._capEngineService.getHeaders('forceUpdate');
        return this._http.put(environment.serverUrl + '/addVersion', versionObj, header);
    }

    getAppVersions() {
        // it wont show spinner if we add this
        // return this.http.get(environment.serverUrl + '/getAppVersions', this.showLoaderHttpOptions);

        //    it will show spinner if we add this
        let header = this._capEngineService.getHeaders('forceUpdate');
        return this._http.get(environment.serverUrl + '/getAppVersions', header);
    }

    forceUpdate(updateObj) {
        let header = this._capEngineService.getHeaders('forceUpdate');
        return this._http.put(environment.serverUrl + '/forceUpdate', updateObj, header);
    }
}



// WEBPACK FOOTER //
// ./src/app/force-update/force-update.service.ts